import React, { useState, useEffect, useContext, useRef, useCallback, useMemo, Suspense } from 'react';
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { postTraining } from './TrainingService';
import $, { event } from 'jquery'
import { TostMsg } from '../../../../App';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { getEmployeeList } from '../../EmployeeList/Service/employeeService';
import { Dropdown } from 'primereact/dropdown';
import { LazyImage } from '../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding';
import { GetMasterSystemAlert, uploadDoc } from '../../../../Services/Global-Services/GlobalServices';
import ERROR_LIST from '../../../../Services/Global-Services/Hadle_Errors';
const ComponentLoader = React.lazy(() => import('../../../../Shared/Sidebar/ComponentLoader'));

export default function AddNewTraining() {
    const [loading, setLoading] = useState(false);
    const toster = useContext(TostMsg);
    const navigate = useHistory()
    let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
    const [ImagePath, setImagePath] = useState("/images/org-img/learn/add.png");
    const [file, setFile] = useState(null);
    let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
    useEffect(() => {
        fetchEmployeeData();
    }, []);
    const [employee, setEmployee] = useState([]);
    const traningValidation = Yup.object().shape({
        title: Yup.string().required("Title is required."),
        startDate: Yup.string().required("Start date is required."),
        endDate: Yup.string().required("End date is required."),
        startTime: Yup.string().required("Start time is required."),
        endTime: Yup.string().required("End time is required."),
        noOfTraining: Yup.string().required("Slots is required."),
        instructorId: Yup.string().required("Instructor is required."),
        email: Yup.string().required("Email is required.").email('Email is invalid.'),
        description: Yup.string().required("Description is required."),
        content: Yup.string().required("Content is required."),
        status: Yup.string().required("status is required."),
        trainingBanner: Yup.mixed().required('Banner Image is required.')
            .test('fileFormat', 'Only png/gif/jpeg files are allowed', value => {
                if (value) {
                    const supportedFormats = ["png", "gif", "jpeg", "jpg"];
                    return supportedFormats.includes(value.split('.').pop());
                }
                return true;
            }),
    })
    const traningForm = useFormik({
        initialValues: {
            title: '',
            startDate: '',
            endDate: '',
            startTime: '',
            endTime: '',
            noOfTraining: '',
            status: '',
            email: '',
            description: '',
            content: '',
            instructorId: '',
            trainingBanner: ''
        },
        validationSchema: traningValidation,
        onSubmit: async (data) => {
            setLoading(true);
            let prams = {
                "id": 0,
                "userId": userDetails.EmpId,
                "orgId": userDetails.OrgId,
                "title": data.title,
                "days": '',
                "startDate": new Date(data.startDate),
                "endDate": new Date(data.endDate),
                "slotCount": data.noOfTraining,
                "startTime": data.startTime,
                "endTime": data.endTime,
                "hostName": data.hostName,
                "email": data.email,
                "isNotificationActive": true,
                "description": data.description,
                "content": data.content,
                "status": Boolean(data.status) ?? true,
                'hostId': data.instructorId,
                'trainingBanner': data.trainingBanner
            }
            try {
                const reaponce = await postTraining(prams);
                traningForm.resetForm();
                setImagePath(null);
                await GetMasterSystemAlertList('Add_Training',0)
                navigate.push('/InstructorTrainingDashboard')
                setLoading(false);
            }
            catch (err) {
                await GetMasterSystemAlertList(' ',1);             
                setLoading(false);
            }
        }
    })

    const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), delay);
        };
    };

    const handleStartDateChange = debounce((event) => {
        const startDate = event.target.value;
        if (startDate) {
            traningForm.setFieldValue('endDate', startDate);
        } else {
            traningForm.setFieldValue('endDate', '');
        }
        traningForm.handleChange(event);
    }, 300);

    //Get Employee List from EmployeeList service
    async function fetchEmployeeData() {
        setLoading(true);
        var params = {
            OrganisationId: userDetails?.OrgId,
            LoggedInEmployeeId: userDetails?.EmpId,
            IsDirectReportOrHierarchy: 0,
            SearchText: "",
            FollowersOnly: 0,
            FollowingsOnly: 0,
            IsExEmployeesAlso: 0,
            pageNumber: 1,
            pageSize: 10000,
            EmployeeId: 0,
             IsSuggestedOnly: 0,
        };
        try {
            let employeesList = await getEmployeeList(params);
            // let employeesList = await data.json();
            setEmployee(employeesList.Data);
            setLoading(false);
        } catch (error) {
            GetMasterSystemAlertList('InvalidRequest',1);     
            setLoading(false);
        }
    }

    const employeeOptionTemplate = useMemo(() => (option) => {
        return (
            <div className="flex align-items-center gap-2">
                <LazyImage alt={option.FullName} src={option.ProfileImage} />
                <span>{option.FullName}</span>
            </div>
        );
    }, []);

    const SelectedEmployees = useCallback((event) => {
        traningForm.setFieldValue('instructorId', event.Id);
        traningForm.setFieldValue('hostName', event.FullName);
    }, []);

    // Upload your feed image and video data
    const handleImageFileChange = useCallback(async (event) => {
        const selectedFile = await event.target.files[0];
        setFile(selectedFile);
    }, []);

    // Inner HTML for image
    const fileInputImageRef = useRef(null);
    function openFileImageInput() {
        fileInputImageRef.current.click();

    }

    useEffect(() => {
        if (file) {
            uploadPolicyDocFile();
        }
    }, [file]);
    // Upload your image and video data
    async function uploadPolicyDocFile() {
        setLoading(true)
        if (!file) {            
            await GetMasterSystemAlertList('No_file_selected',2);             
            return;
        }
        const formData = new FormData();
        formData.append("files", file);
        try {
            const response = await uploadDoc(formData);
            const data = await response;
            const ImageURL = data?.Data[0];
            if (ImageURL) {
              await GetMasterSystemAlertList('File_Uploaded',0); 
                setImagePath(ImageURL)
                traningForm.setFieldValue('trainingBanner', ImageURL);
            }
            $(".upload-img").hide("slow");
            $(".input-Btn").show("slow");
        } catch (error) {
            setLoading(false);
        toster.current.error(ERROR_LIST.UploadFileError);
        } finally {
            setFile(null);
            setLoading(false);
        toster.current.error(ERROR_LIST.UploadFileError);
        }
    }

    const GetMasterSystemAlertList= useCallback(async(message, type)=> {	
        SystemAlerts?.filter((msg) => {
            if (msg?.Name == message && type == 0) {
				toster.current.success(msg?.Desc);
			} else if(msg?.Name == message && type == 1){
                toster.current.error(msg?.Desc);
            } else if(msg?.Name == message &&  type == 2) {
				toster.current.warn(msg?.Desc);
			}          
        });
	},[]);

    return (
        <div className="position-relation">
            <div id="circular-menu" className="circular-menu">
                <a className="floating-btn" >
                    <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
                    <i aria-hidden="true" className="fa fa-times"></i>
                </a>
                <div className="items-wrapper">
                    <div className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </div>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="languages-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </a>
                    <Link to="" className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </Link>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="activity-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                    </a>
                </div>
            </div>
            {/* <!-- row --> */}
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-8 shrink-w">
                        <div className="form-head d-flex flex-wrap align-items-center mb-3">
                            <div className="me-auto">
                                <h2 className="font-w600 mb-0">Add Training</h2>
                                <p className="text-light">Lorem ipsum dolor sit amet</p>
                            </div>
                            <div className="rightside-tabs">
                                <Link to="/InstructorTrainingDashboard"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-arrow-left-short" viewBox="0 0
16 16"><path fillRule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.7
07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"></path></svg></Link>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="col-xl-12">
                                    <div className="supp-req">
                                        <div className="addcourseform">
                                            <form onSubmit={traningForm.handleSubmit}>
                                                <span className="tagtitle">Basic Info</span>
                                                <div className="row">
                                                    <div className="mb-4 col-md-12">
                                                        <input type="text" cols="1" rows="4" name='title'
                                                            className={"form-control bg-chng" + (traningForm.errors.title && traningForm.touched.title ? 'is-invalid' : '')}
                                                            onChange={traningForm.handleChange}
                                                            value={traningForm.values.title}
                                                            placeholder="Your Topic goes here..|" />
                                                        <div className="invalid-feedback">
                                                            {traningForm.errors.title && traningForm.touched.title ? traningForm.errors.title : null}
                                                        </div>
                                                    </div>
                                                    {/* :-{JSON.stringify(selectedEmployees)} */}
                                                    <div className="mb-4 col-md-6">
                                                        <label className="form-label">Repoting Manager </label>
                                                        {loading ? (
                                                            <div>Loading...</div>
                                                        ) : (
                                                            <Dropdown value={traningForm.values.instructorId} onChange={(e) => { SelectedEmployees(e.value) }} options={employee}
                                                                optionLabel="FullName" className="default-select form-control wide mb-3"
                                                                placeholder="Select reporting manager" itemTemplate={employeeOptionTemplate} checkmark={true} highlightOnSelect={false} />
                                                        )}
                                                        <div className="invalid-feedback">
                                                            {traningForm.errors.instructorId && traningForm.touched.instructorId ? traningForm.errors.instructorId : null}
                                                        </div>
                                                    </div>
                                                    {/* <div className="mb-4 col-md-6">
                                                        <label className="form-label">Instructor Name</label>
                                                        <div className="cover-form">
                                                            <div><i className="fa fa-user-o" aria-hidden="true"></i></div>
                                                            <input type="text"
                                                                name='hostName'
                                                                className={"form-control" + (traningForm.errors.hostName && traningForm.touched.hostName ? 'is-invalid' : '')}
                                                                onChange={traningForm.handleChange}
                                                                value={traningForm.values.hostName} /></div>
                                                       
                                                    </div> */}
                                                    <div className="mb-4 col-md-6">
                                                        <label className="form-label"> Email</label>
                                                        <div className="cover-form">
                                                            <div><i className="fa fa-user-o" aria-hidden="true"></i></div>
                                                            <input type="text" name='email'
                                                                className={"form-control" + (traningForm.errors.email && traningForm.touched.email ? 'is-invalid' : '')}
                                                                onChange={traningForm.handleChange}
                                                                value={traningForm.values.email} /></div>
                                                        <div className="invalid-feedback">
                                                            {traningForm.errors.email && traningForm.touched.email ? traningForm.errors.email : null}
                                                        </div>
                                                    </div>
                                                    <div className="mb-4 col-md-12">
                                                        <label className="form-label" >Content</label>
                                                        <input type="text" name='content'
                                                            className={"form-control" + (traningForm.errors.content && traningForm.touched.content ? 'is-invalid' : '')}
                                                            onChange={traningForm.handleChange}
                                                            value={traningForm.values.content} />
                                                        <div className="invalid-feedback">
                                                            {traningForm.errors.content && traningForm.touched.content ? traningForm.errors.content : null}
                                                        </div>
                                                    </div>
                                                    <div className="mb-4 col-md-12">
                                                        <label className="form-label">Description</label>
                                                        <div className="cover-form">
                                                            <textarea
                                                                name='description'
                                                                className={"form-control  h-auto" + (traningForm.errors.description && traningForm.touched.description ? 'is-invalid' : '')}
                                                                onChange={traningForm.handleChange}
                                                                value={traningForm.values.description} rows="6" cols="1" placeholder="Mention Job Description"></textarea></div>
                                                        <div className="invalid-feedback">
                                                            {traningForm.errors.description && traningForm.touched.description ? traningForm.errors.description : null}
                                                        </div>
                                                    </div>
                                                    <div className="mb-4 col-md-6">
                                                        <label className="form-label" >No Of Slot</label>
                                                        <input type="number" name='noOfTraining'
                                                            className={"form-control  h-auto" + (traningForm.errors.noOfTraining && traningForm.touched.noOfTraining ? 'is-invalid' : '')}
                                                            onChange={traningForm.handleChange}
                                                            value={traningForm.values.noOfTraining} />
                                                        <div className="invalid-feedback">
                                                            {traningForm.errors.noOfTraining && traningForm.touched.noOfTraining ? traningForm.errors.noOfTraining : null}
                                                        </div>
                                                    </div>
                                                    <div className="mb-4 col-md-6">
                                                        <div className="card">
                                                            <div className="card-body">
                                                                <div onClick={() => { openFileImageInput() }} className="loadresumes"><div className="inner">
                                                                    <img src={ImagePath} className="w-100" />
                                                                    <span>
                                                                        Upload Cover Image</span>
                                                                </div>
                                                                    <input type='file' ref={fileInputImageRef}
                                                                        style={{ display: "none" }} className="form-control" name='trainingBanner' accept='image/png, image/gif, image/jpeg' onChange={handleImageFileChange} />
                                                                </div>
                                                                <div>{(traningForm.errors.trainingBanner) ? <p style={{ color: 'red' }}>{traningForm.errors.trainingBanner}</p> : null}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="mb-4 col-md-6">
                                                        <label className="form-label">Status</label>
                                                        <div className="check-leveloption">
                                                            <div className="inner">
                                                                <input type="radio" name='status' onChange={traningForm.handleChange}
                                                                    value="true" checked={traningForm.values.status === "true"} id="one" />
                                                                <span>Open</span>
                                                            </div>
                                                            <div className="inner">
                                                                <input type="radio" name='status'
                                                                    onChange={traningForm.handleChange}
                                                                    value="false"
                                                                    checked={traningForm.values.status === "false"}
                                                                    id="two" />
                                                                <span>Close</span>
                                                            </div>
                                                            <div className="invalid-feedback">
                                                                {traningForm.errors.status && traningForm.touched.status ? traningForm.errors.status : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="mb-4 col-md-6">
                                                        <label className="form-label">Start Date</label>
                                                        <div className="cover-form">
                                                            <div><i className="fa fa-money" aria-hidden="true"></i></div>
                                                            <input id='txtDate' type="date" name='startDate'
                                                                min={new Date().toISOString().split('T')[0]}
                                                                className={"form-control  h-auto" + (traningForm.errors.startDate && traningForm.touched.startDate ? 'is-invalid' : '')}
                                                                onChange={traningForm.handleChange}
                                                                // onChange={handleStartDateChange}
                                                                value={traningForm.values.startDate} /></div>
                                                        <div className="invalid-feedback">
                                                            {traningForm.errors.startDate && traningForm.touched.startDate ? traningForm.errors.startDate : null}
                                                        </div>
                                                    </div>
                                                    <div className="mb-4 col-md-6">
                                                        <label className="form-label">End Date</label>
                                                        <div className="cover-form">
                                                            <div><i className="fa fa-money" aria-hidden="true"></i></div>
                                                            <input type="date" name='endDate' min={traningForm?.values?.startDate ? new Date(traningForm.values.startDate).toISOString().split('T')[0] : new Date()?.toISOString()?.split('T')[0]}
                                                                className={"form-control  h-auto" + (traningForm.errors.endDate && traningForm.touched.endDate ? 'is-invalid' : '')}
                                                                onChange={traningForm.handleChange}
                                                                value={traningForm.values.endDate} /></div>
                                                        <div className="invalid-feedback">
                                                            {traningForm.errors.endDate && traningForm.touched.endDate ? traningForm.errors.endDate : null}
                                                        </div>
                                                        <label className="invalid-feedback">the end date is always greater than and equal to the start date.</label>
                                                    </div>
                                                    <div className="mb-4 col-md-6">
                                                        <label className="form-label">Duration From</label>
                                                        <div className="cover-form">
                                                            <div><i className="fa fa-money" aria-hidden="true"></i></div>
                                                            <input type="time" name='startTime'
                                                                className={"form-control  h-auto" + (traningForm.errors.startTime && traningForm.touched.startTime ? 'is-invalid' : '')}
                                                                onChange={traningForm.handleChange}
                                                                value={traningForm.values.startTime} /></div>
                                                        <div className="invalid-feedback">
                                                            {traningForm.errors.startTime && traningForm.touched.startTime ? traningForm.errors.startTime : null}
                                                        </div>
                                                    </div>
                                                    <div className="mb-4 col-md-6">
                                                        <label className="form-label">Duration To</label>
                                                        <div className="cover-form">
                                                            <div><i className="fa fa-money" aria-hidden="true"></i></div>
                                                            <input type="time" name='endTime'
                                                                className={"form-control  h-auto" + (traningForm.errors.endTime && traningForm.touched.endTime ? 'is-invalid' : '')}
                                                                onChange={traningForm.handleChange}
                                                                value={traningForm.values.endTime} /></div>
                                                        <div className="invalid-feedback">
                                                            {traningForm.errors.endTime && traningForm.touched.endTime ? traningForm.errors.endTime : null}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="btns-grp">
                                                        <button type='submit' className="savebtn-click">Save</button>
                                                        <button className="publish-click">Publish</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-xl-4 d-none"> */}
                            {/* <div className="col-xl-4">
                                <div className="row addcourseform">
                                    <div className="col-xl-12">
                                        <div className="mb-4 col-md-12">
                                            <label className="form-label">Status</label>
                                            <div className="check-leveloption">
                                                <div className="inner">
                                                    <input type="radio" id="one" name="fav_language" value="ONE" />
                                                    <span>Open</span>
                                                </div>
                                                <div className="inner">
                                                    <input type="radio" id="two" name="fav_language" value="TWO" />
                                                    <span>Close</span>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="mb-2 col-md-12">
                                            <label className="form-label">Skills Required</label>
                                            <div className="cover-form">
                                                <div><i className="fa fa-bookmark-o" aria-hidden="true"></i></div>
                                                <select id="inputState" className="default-select form-control wide">
                                                    <option selected="">Choose...</option>
                                                    <option>Facebook</option>
                                                    <option>Instagram</option>
                                                    <option>Youtube</option>
                                                </select></div>
                                        </div>
                                        <div className="divider mt-4">
                                            <hr /><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-square-dotted" viewBox="0 0 16 16">
                                                <path d="M2.5 0q-.25 0-.487.048l.194.98A1.5 1.5 0 0 1 2.5 1h.458V0zm2.292 0h-.917v1h.917zm1.833 0h-.917v1h.917zm1.833 0h-.916v1h.916zm1.834 0h-.917v1h.917zm1.833 0h-.917v1h.917zM13.5 0h-.458v1h.458q.151 0 .293.029l.194-.981A2.5 2.5 0 0 0 13.5 0m2.079 1.11a2.5 2.5 0 0 0-.69-.689l-.556.831q.248.167.415.415l.83-.556zM1.11.421a2.5 2.5 0 0 0-.689.69l.831.556c.11-.164.251-.305.415-.415zM16 2.5q0-.25-.048-.487l-.98.194q.027.141.028.293v.458h1zM.048 2.013A2.5 2.5 0 0 0 0 2.5v.458h1V2.5q0-.151.029-.293zM0 3.875v.917h1v-.917zm16 .917v-.917h-1v.917zM0 5.708v.917h1v-.917zm16 .917v-.917h-1v.917zM0 7.542v.916h1v-.916zm15 .916h1v-.916h-1zM0 9.375v.917h1v-.917zm16 .917v-.917h-1v.917zm-16 .916v.917h1v-.917zm16 .917v-.917h-1v.917zm-16 .917v.458q0 .25.048.487l.98-.194A1.5 1.5 0 0 1 1 13.5v-.458zm16 .458v-.458h-1v.458q0 .151-.029.293l.981.194Q16 13.75 16 13.5M.421 14.89c.183.272.417.506.69.689l.556-.831a1.5 1.5 0 0 1-.415-.415zm14.469.689c.272-.183.506-.417.689-.69l-.831-.556c-.11.164-.251.305-.415.415l.556.83zm-12.877.373Q2.25 16 2.5 16h.458v-1H2.5q-.151 0-.293-.029zM13.5 16q.25 0 .487-.048l-.194-.98A1.5 1.5 0 0 1 13.5 15h-.458v1zm-9.625 0h.917v-1h-.917zm1.833 0h.917v-1h-.917zm1.834-1v1h.916v-1zm1.833 1h.917v-1h-.917zm1.833 0h.917v-1h-.917zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3z" />
                                            </svg></div>
                                        <div className="mb-2 col-md-12">
                                            <label className="form-label">Added Skill</label>
                                            <ul className="added-socialmedia">
                                                <li>Powerpoint<i className="fa fa-trash-o"></i></li>
                                                <li>BootStrap<i className="fa fa-trash-o"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="btns-grp">
                                    <button className="savebtn-click">Save</button>
                                    <button className="publish-click">Publish</button>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="modal fade" id="contact-manager"> */}
            {/* <div className="" id="contact-manager">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title m-auto">Contact Your Reporting Manager htmlFor Any Leave Clarifications</h5>

                        </div>
                        <div className="modal-body text-center">
                            <form>
                                <div className="form-group text-left">
                                    <label>Repoting Manager</label>
                                    <select className="default-select form-control wide mb-3">
                                        <option selected disabled>Select reporting manager</option>
                                        <option>Arun Mishra</option>
                                        <option>Pragya Tiwari</option>
                                        <option>Alisha Goyal</option>
                                    </select></div>
                                <div className="form-group text-left">
                                    <label className="mt-3">Reason</label>
                                    <textarea rows="4" cols="1" className="form-control"></textarea></div>

                            </form>


                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger light" data-bs-dismiss="modal">Decline</button>
                            <button type="button" className="btn btn-primary">Accept</button>
                        </div>
                    </div>
                </div>
            </div> */}

            {loading ? <Suspense >
                <ComponentLoader />
            </Suspense> : ''}
        </div>
    )

}
